import { isEmpty } from 'lodash'
import store from '../../../../../../store'

export function generateAnamnesis() {
  const treatments = store.getters['newAttendanceForm/treatments']
  const answers = store.getters['newAttendanceForm/answers']
  const extraAnswers = store.getters['newAttendanceForm/extraAnswers']
  const parameters = store.getters['newAttendanceForm/parameters']

  const biologicTreatments = treatments.filter(
    (treatment) =>
      Object.keys(extraAnswers['indicated-treatments']).includes(String(treatment.id)) &&
      treatment.medicine.category.name === 'Biológico',
  )

  let anamnesis = `Paciente com ${parameters['asthma:hypothesis'].label.text}`
  if (!isEmpty(answers['6']) && answers['6'] !== 'sem-informacao') {
    anamnesis += `, com início na ${answers['6']}`
  }
  if (
    !isEmpty(answers['18']) &&
    answers['18'] !== 'sem-informacao' &&
    answers['18'] !== '0' &&
    !isEmpty(biologicTreatments)
  ) {
    anamnesis += `. ${answers['18'].replace(
      '+',
      ' ou mais',
    )} exarcebações graves com necessidade de corticóide sistêmico no último ano`
  }
  if (
    !isEmpty(answers['9']) &&
    answers['9'] !== 'sem-informacao' &&
    answers['9'] !== '0' &&
    !isEmpty(biologicTreatments)
  ) {
    anamnesis += `. Precisou buscar o pronto atendimento ou foi hospitalizado ${answers['9']} vezes no último ano, por exarcebação`
  }
  if (!isEmpty(biologicTreatments)) {
    anamnesis += `. Não apresenta níveis adequados de controle, apesar da terapia instituída.`
  } else {
    anamnesis += `. Esse medicamento é necessário para manutenção dos níveis de controle de asma.`
  }

  return anamnesis
}
